export * from './getDomain';
export * from './getPrefix';
export * from './getBaseUrl';
